export default __webpack_public_path__ + "static/media/Guide Book.fae6560d.svg";